const DeleteIcon = ({ width = 14, height = 18, color = '#444446' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53125 1.71484H9.47243" stroke={color} strokeWidth="1.6" />
      <path d="M0 4.75781H14" stroke={color} strokeWidth="1.6" />
      <path
        d="M2.0625 4.75V14.8899L3.70956 16.2785H10.2978L11.9449 14.8899V4.75"
        stroke={color}
        strokeWidth="1.6"
      />
      <path d="M5.35156 8.04297V12.9838" stroke={color} strokeWidth="1.6" />
      <path d="M8.64844 8.04297V12.9838" stroke={color} strokeWidth="1.6" />
    </svg>
  )
}

export default DeleteIcon
